import { defineStore } from 'pinia'
import { fetchItem } from '@/apps/traforama/api/mediaKits'
import useCrudStore from '@/hooks/useCrudStore'

export const useMediaKitsStore = defineStore('mediaKits', () => {
  const { FetchItem, itemById } = useCrudStore({
    fetchItem
  })

  return {
    FetchItem,
    itemById
  }
})
